import { COUNTRIES } from 'resources/company/company.constants';
import useCompany from 'resources/company/hooks/useCompany';
import { useCurrentUser } from 'resources/user/hooks';

export const COUNTRY_BASED_WORDING = {
  [COUNTRIES.CANADA]: {
    ZIP: 'Postal Code',
    STATE: 'Province',
    UNDER_CONTRACT: 'Contract Signed',
    UNDER_CONTRACT_DATE: 'Contract Signed Date',
    AFTER_UNDER_CONTRACT: 'DAYS AFTER CONTRACT SIGNED',
    BUYER_UNDER_CONTRACT_KIT: 'Buyer Contract Signed Kit',
    SELLER_UNDER_CONTRACT_KIT: 'Seller Contract Signed Kit',
  },
  [COUNTRIES.UNITED_STATES]: {
    ZIP: 'ZIP',
    STATE: 'State',
    UNDER_CONTRACT: 'Under Contract',
    UNDER_CONTRACT_DATE: 'Under Contract Date',
    AFTER_UNDER_CONTRACT: 'DAYS AFTER UNDER CONTRACT',
    BUYER_UNDER_CONTRACT_KIT: 'Buyer Under Contract Kit',
    SELLER_UNDER_CONTRACT_KIT: 'Seller Under Contract Kit',
  },
};

const useCountryBasedWording = () => {
  const { data: user } = useCurrentUser();
  const { data: company } = useCompany(user?.company_id, { enabled: !!user });

  return COUNTRY_BASED_WORDING?.[company?.country] || COUNTRY_BASED_WORDING[COUNTRIES.UNITED_STATES];
};

export default useCountryBasedWording;
